<template>
  <div class="custom-cursor">
    <div class="custom-cursor__wrapper" :style="cursorPoint">
      <cursor-arrow v-if="showActivityCursor" :is-left-to-right="isLeftToRight" />
      <flow-cursor v-if="newFlow" :is-top-to-bottom="isTopToBottom" :is-start-point="isFlowStartPoint" />
    </div>
  </div>
</template>

<script>
import CursorArrow from "./CursorArrow.vue";
import FlowCursor from "../../sidebar/flow/FlowCursor.vue";
import { CustomCursorTypes } from "../../../../../utils/constants";
export default {
  components: {
    CursorArrow,
    FlowCursor,
  },
  data() {
    return {
      xChild: 0,
      yChild: 0,
      xParent: 0,
      yParent: 0,
    };
  },
  computed: {
    isLeftToRight() {
      return this.xChild >= this.$store.state.cells.arrow.startPlayerX;
    },
    isTopToBottom() {
      return this.yChild >= this.$store.state.customFlow.newArrow.startShapeY;
    },
    cursorPoint() {
      const translateX = `${this.xChild - 3}px`;
      let translateY = `${this.yChild}px`;

      if (this.showActivityCursor) {
        translateY = `${this.yChild - 3}px`;
      } else if (!this.isFlowStartPoint && this.isTopToBottom) {
        translateY = `${this.yChild - 18}px`;
      }

      return `transform: translateX(${translateX}) translateY(${translateY}) translateZ(0) translate3d(0, 0, 0);`;
    },
    showActivityCursor() {
      return this.$store.state.cells.arrow.activeCursor !== CustomCursorTypes.Default;
    },
    newFlow() {
      return this.$store.state.customFlow.newArrow.activeCursor !== CustomCursorTypes.Default;
    },
    isFlowStartPoint() {
      return this.$store.state.customFlow.newArrow.activeCursor === CustomCursorTypes.Start;
    },
  },
  mounted() {
    document.addEventListener("mousemove", this.moveCursor);
    document.addEventListener("mouseover", this.setInitialMousePosition, false);
  },
  unmounted() {
    document.removeEventListener("mousemove", this.moveCursor);
  },
  methods: {
    moveCursor(e) {
      this.xChild = e.clientX;
      this.yChild = e.clientY;
      this.xParent = e.clientX - 15;
      this.yParent = e.clientY - 15;
    },
    // without this function it's necessary for user to move the mouse a little bit to show custom cursor
    setInitialMousePosition(e) {
      this.moveCursor(e);
      document.removeEventListener("mouseover", this.setInitialMousePosition, false);
    },
  },
};
</script>

<style lang="less" scoped>
.custom-cursor {
  &__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
  }
}
</style>
